var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidTier2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 80,
    viewBox: "0 0 94 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3141 78.1575L90.798 59.4411C92.5441 58.5681 93.4182 56.8867 93.4204 55.2043V50.0381H0.78125V55.2043C0.783408 56.8867 1.65754 58.5681 3.40364 59.4411L39.8875 78.1575C44.4284 80.4279 49.7733 80.4279 54.3141 78.1575Z",
    fill: "url(#paint0_linear_8129_25815)",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8875 27.152C44.4284 24.8816 49.7732 24.8816 54.3141 27.152L90.798 45.394C94.2945 47.1423 94.2945 52.132 90.798 53.8802L54.3141 72.1222C49.7733 74.3926 44.4284 74.3926 39.8875 72.1222L3.40364 53.8802C-0.0928771 52.132 -0.0928826 47.1423 3.40364 45.394L39.8875 27.152Z",
    fill: "url(#paint1_linear_8129_25815)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3155 72.1226L90.7994 53.8806C92.391 53.0848 93.2581 51.6174 93.4007 50.0898C92.3553 52.4824 91.9218 52.6269 90.6 53.4133L54.2025 71.4212C53.1662 71.8855 50.3493 73.0922 46.9206 73.0922C43.492 73.0922 40.872 71.8855 39.9566 71.4212C28.2646 65.564 4.53122 53.9776 3.40501 53.3776C2.2788 52.7775 1.28554 51.4248 0.929688 50.8235C1.24566 52.0744 2.07077 53.2135 3.40501 53.8806L39.8889 72.1226C44.4298 74.393 49.7746 74.393 54.3155 72.1226Z",
    fill: "url(#paint2_linear_8129_25815)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8129_25815)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0451 16.8997C45.0717 14.8863 49.8113 14.8863 53.838 16.8996L86.1905 33.0759C89.2911 34.6262 89.2911 39.0508 86.1905 40.6011L53.838 56.7774C49.8114 58.7907 45.0718 58.7907 41.0451 56.7774L8.69262 40.6011C5.59205 39.0508 5.59204 34.6262 8.69262 33.0759L41.0451 16.8997Z",
    fill: "url(#paint3_linear_8129_25815)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36719 36.8389V42.218C6.3691 43.7099 7.14424 45.2009 8.69262 45.9751L41.0451 62.572C45.0718 64.5854 49.8113 64.5854 53.838 62.572L86.1905 45.9751C87.7389 45.2009 88.514 43.7099 88.5159 42.218V36.848C88.5127 38.3387 87.7376 39.8279 86.1905 40.6015L53.838 56.7777C49.8114 58.7911 45.0718 58.7911 41.0451 56.7777L8.69262 40.6015C7.14233 39.8263 6.36719 38.3326 6.36719 36.8389Z",
    fill: "url(#paint4_linear_8129_25815)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8404 56.777L86.1929 40.6008C87.6042 39.8951 88.3731 38.5939 88.4996 37.2393C87.5726 39.3609 87.1882 39.489 86.0161 40.1863L53.7402 56.1551C52.8212 56.5668 50.3233 57.6368 47.283 57.6368C44.2426 57.6368 41.9192 56.5668 41.1075 56.1551C30.7395 50.9611 9.6937 40.6867 8.69502 40.1547C7.69634 39.6226 6.81556 38.4231 6.5 37.8898C6.78019 38.9991 7.51186 40.0092 8.69502 40.6008L41.0475 56.777C45.0741 58.7903 49.8137 58.7903 53.8404 56.777Z",
    fill: "url(#paint5_linear_8129_25815)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_8129_25815)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1297 8.80305C45.2581 7.23883 48.9405 7.23883 52.0689 8.80304L77.2044 21.3708C79.6134 22.5753 79.6134 26.0129 77.2044 27.2174L52.0689 39.7852C48.9405 41.3494 45.2582 41.3494 42.1297 39.7852L16.9942 27.2174C14.5853 26.0129 14.5853 22.5753 16.9942 21.3708L42.1297 8.80305Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 24.2939V29.6117C15.189 30.7708 15.7912 31.9292 16.9942 32.5307L42.1297 45.4253C45.2582 46.9895 48.9405 46.9895 52.0689 45.4253L77.2044 32.5307C78.4074 31.9292 79.0096 30.7708 79.0111 29.6117V24.301C79.0087 25.4592 78.4065 26.6162 77.2044 27.2172L52.0689 39.785C48.9405 41.3492 45.2582 41.3492 42.1297 39.785L16.9942 27.2172C15.7897 26.615 15.1875 25.4545 15.1875 24.2939Z",
    fill: "#E4E8F3",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.077 39.7849L77.2125 27.2171C78.309 26.6689 78.9064 25.6579 79.0047 24.6055C78.2844 26.2538 77.9858 26.3534 77.0751 26.8951L51.9991 39.3017C51.2851 39.6216 49.3444 40.4529 46.9823 40.4529C44.6201 40.4529 42.815 39.6216 42.1844 39.3017C34.1292 35.2663 17.7781 27.2839 17.0022 26.8705C16.2263 26.4572 15.542 25.5252 15.2969 25.1109C15.5146 25.9727 16.083 26.7575 17.0022 27.2171L42.1378 39.7849C45.2662 41.3491 48.9485 41.3491 52.077 39.7849Z",
    fill: "url(#paint6_linear_8129_25815)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_8129_25815)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1634 1.73256C45.4893 0.569618 48.2269 0.569616 50.5528 1.73255L69.2402 11.0762C71.0311 11.9717 71.0311 14.5275 69.2402 15.423L50.5528 24.7666C48.2269 25.9296 45.4893 25.9296 43.1634 24.7666L24.476 15.423C22.6851 14.5275 22.6851 11.9717 24.476 11.0762L43.1634 1.73256Z",
    fill: "url(#paint7_linear_8129_25815)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bi_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1328 13.25V17.6444C23.1339 18.5062 23.5817 19.3674 24.476 19.8146L43.1634 29.4013C45.4893 30.5642 48.2269 30.5642 50.5528 29.4013L69.2402 19.8146C70.1345 19.3674 70.5823 18.5062 70.5834 17.6444V13.2553C70.5816 14.1163 70.1338 14.9765 69.2402 15.4234L50.5528 24.767C48.2269 25.93 45.4893 25.93 43.1634 24.767L24.476 15.4234C23.5806 14.9756 23.1328 14.1128 23.1328 13.25Z",
    fill: "#E4E8F3",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_8129_25815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5556 24.7668L69.243 15.4231C70.0582 15.0155 70.5023 14.2639 70.5754 13.4814C70.0399 14.7069 69.8179 14.781 69.1408 15.1837L50.4977 24.4075C49.9669 24.6454 48.5241 25.2634 46.7679 25.2634C45.0117 25.2634 43.6697 24.6454 43.2009 24.4075C37.2121 21.4074 25.0557 15.4728 24.4788 15.1654C23.902 14.8581 23.3932 14.1652 23.2109 13.8572C23.3728 14.4979 23.7954 15.0814 24.4788 15.4231L43.1662 24.7668C45.4921 25.9297 48.2297 25.9297 50.5556 24.7668Z",
    fill: "url(#paint8_linear_8129_25815)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8129_25815",
    x: 0.78125,
    y: 49.8009,
    width: 92.6387,
    height: 30.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_8129_25815",
    x: -10.3955,
    y: 14.2724,
    width: 114.992,
    height: 70.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.58839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8129_25815",
    x: 0.594384,
    y: 49.7545,
    width: 93.1413,
    height: 24.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167652,
    result: "effect1_foregroundBlur_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8129_25815",
    x: 1.87366,
    y: 15.3896,
    width: 91.1355,
    height: 57.6794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_8129_25815",
    x: -13.6328,
    y: -4.61035,
    width: 122.148,
    height: 82.8979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_8129_25815",
    x: -2.0463,
    y: 28.4254,
    width: 98.9754,
    height: 44.0701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.20674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_8129_25815",
    x: 6.07933,
    y: 36.8186,
    width: 82.8413,
    height: 21.8892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337,
    result: "effect1_foregroundBlur_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_8129_25815",
    x: 11.1419,
    y: 7.62988,
    width: 71.9155,
    height: 47.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_8129_25815",
    x: -4.8125,
    y: -12.3701,
    width: 103.824,
    height: 73.3286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_8129_25815",
    x: 8.65083,
    y: 17.7573,
    width: 76.8976,
    height: 35.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.26834
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.163417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_8129_25815",
    x: 14.97,
    y: 24.2786,
    width: 64.3607,
    height: 17.0062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417,
    result: "effect1_foregroundBlur_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_8129_25815",
    x: 19.1328,
    y: 0.860352,
    width: 55.4512,
    height: 37.4131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_8129_25815",
    x: 3.13281,
    y: -19.1396,
    width: 87.4512,
    height: 64.7783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bi_8129_25815",
    x: 18.273,
    y: 8.39022,
    width: 57.1707,
    height: 26.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.42989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25815",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.121495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_8129_25815",
    x: 22.9679,
    y: 13.2385,
    width: 47.8512,
    height: 12.6437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495,
    result: "effect1_foregroundBlur_8129_25815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8129_25815",
    x1: 93.4204,
    y1: 55.1551,
    x2: 0.781252,
    y2: 56.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8129_25815",
    x1: 93.4204,
    y1: 49.6371,
    x2: -0.536051,
    y2: 49.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8129_25815",
    x1: 0.929688,
    y1: 50.0898,
    x2: 93.4008,
    y2: 50.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8129_25815",
    x1: 6.36719,
    y1: 36.8385,
    x2: 91.0484,
    y2: 36.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8129_25815",
    x1: 88.5159,
    y1: 41.994,
    x2: 6.36719,
    y2: 39.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8129_25815",
    x1: 6.5,
    y1: 37.2393,
    x2: 88.4997,
    y2: 37.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8129_25815",
    x1: 15.2969,
    y1: 24.6055,
    x2: 79.0047,
    y2: 24.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8129_25815",
    x1: 58.1727,
    y1: 5.65464,
    x2: 32.9116,
    y2: 18.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8129_25815",
    x1: 23.2109,
    y1: 13.4814,
    x2: 70.5754,
    y2: 13.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTier2Icon);
export default __webpack_public_path__ + "static/media/bfid-tier_2-icon.c688b403f907d88acfd6ad16cab9a97b.svg";
export { ForwardRef as ReactComponent };